var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 1000,
    y1: 0,
    y2: -1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1000 500.1v376.4c0 57.5-43.4 110.1-100 120.9-8.4 1.6-17.1 2.5-25.6 2.5-250.1.1-500.2.1-750.3.1-61.3 0-114.8-47-122.8-108q-.3-2.1-.6-4.1-.2-2-.3-4.1-.2-2-.3-4v-4.1C0 624.9 0 374.2 0 123.5 0 66 43.4 13.3 100 2.6 108.4 1 117.1.1 125.6.1 375.9 0 626.2 0 876.5 0 934 0 986.7 43.4 997.4 100c1.5 8.4 2.5 17.1 2.5 25.6.1 124.8.1 249.7.1 374.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M332.2 499.4c0 68.1-48.4 119.4-111.5 119.4-29.3 0-50.1-8.5-68.7-28.2v43.9c0 16.9-3.4 32.1-18.6 45-17.4 14.7-41.1 9.6-45.6 8.5-3.3-.6-4.5-1.1-4.5-1.1V381.8h64.2v24.8c18-22.5 39.4-32.1 72.7-32.1 65.3 0 112 51.2 112 124.9zm-60.8-2.8c0-36-27.6-63.6-63.6-63.6-30.4 0-63.7 28.2-63.7 63.1 0 35.4 28.2 64.7 63.7 64.7 35.4 0 63.6-28.2 63.6-64.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M423.4 492.1c0 26.5 2.8 58.6 28.7 93.4.6.6 1.7 2.3 1.7 2.3-10.7 18-23.6 30.4-41.1 30.4-13.5 0-27-7.3-38.3-19.7-11.8-13.5-17.4-31-17.4-49.5V305.8h65.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebaf00",
    d: "M749.4 610.9h-79.9l77.7-114.3-77.7-114.8h79.9l77.2 114.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m808 424 28.7-42.2h80l-69.3 101.9zM848 509.6c.5 1.7 23.6 38.8 41.1 59.1 12.9 15.2 23.1 24.2 23.1 24.2-5.7 6.7-20.3 24.7-41.1 25.3-19.7 0-36.6-10.1-49.6-30.4L808 569.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M681.9 545c-22 46.7-62.5 73.2-109.3 73.2-67 0-120.5-53.5-120.5-121 0-68.1 53.5-122.7 118.8-122.7 68.7 0 121.1 53.5 121.1 124.9 0 7.4-.6 11.9-1.7 15.2H514.1c2.8 25.9 21.9 49.6 55.2 49.6 18.5 0 27.5-6.8 41.1-19.2zm-165.6-72h111.5c-5.1-25.3-27-44.5-56.3-44.5-28.7 0-49.5 18-55.2 44.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlex);
export default __webpack_public_path__ + "static/media/plex.57b9fc791902a69b2487192bb8988a90.svg";
export { ForwardRef as ReactComponent };